// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_4N0C3","alignToEdge":"CYkRf","buttonIcon":"jnNsB","buttonCaption":"QTtYx","buttonSpacer":"dIQTj"};